var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPlaystation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#0070D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0584 158.627C38.585 162.94 40.7428 171.136 54.5527 175.018C68.7942 179.763 84.3303 181.058 99.4349 178.469C100.298 178.469 101.161 178.038 101.593 178.038V163.372L86.9197 168.117C81.3094 169.842 75.6991 170.273 70.0888 168.979C65.7732 167.685 66.6364 165.097 71.8151 162.94L101.593 152.588V136.627L60.163 150.862C54.9843 152.588 49.8055 155.176 45.0584 158.627ZM145.18 93.9223V135.764C162.874 144.392 176.684 135.764 176.684 113.334C176.684 90.4714 168.485 80.1187 144.749 71.9229C132.233 67.6092 119.287 63.727 106.34 61.1388V185.803L136.549 194.861V90.0401C136.549 85.2951 136.549 81.8442 140.002 83.1383C144.749 84.4324 145.18 89.1774 145.18 93.9223ZM201.283 148.705C188.768 144.392 175.389 142.666 162.443 143.96C155.538 144.392 149.064 146.117 143.022 148.274L141.728 148.705V165.529L169.779 155.176C175.389 153.45 181 153.019 186.61 154.313C190.926 155.607 190.063 158.195 184.884 160.352L141.728 176.313V192.704L201.283 170.705C205.599 168.979 209.483 166.823 212.935 163.372C215.956 159.058 214.661 153.019 201.283 148.705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlaystation);
export default __webpack_public_path__ + "static/media/logo-playstation.4b98cad7257dcb78b0bc1d7d228ecabe.svg";
export { ForwardRef as ReactComponent };